import roller from 'common/module/ui/roller';
import { runAfterDesobfuscation } from 'common/tools/seo/desobfuscation';

import applicationBootstrap from 'website/bootstrap';
// theaters / showtimes UI
import theaterButtons from 'website/containers/user/theaterButtons';
import initPlayer from 'website/module/player';
import carousel from 'website/module/ui/carousel';
import loadAccesLibre from 'website/third_party/acces-libre';

// bootstrap the application / store
applicationBootstrap().then(() => {
  initPlayer();

  theaterButtons();

  carousel();

  roller();
  runAfterDesobfuscation(() => {
    loadAccesLibre();
  });
});
